<template>
	<div class="layout-center-container">
		<div class="header-banner" :style="tabHeight ? { 'height': tabHeight + 'px' } : {}">
			<div v-if="!shouldHideInfo" class="header-company-info">
				<div class="header-title">{{ bannerContent }}</div>
				<div class="header-en mt-12">{{ enContent }}</div>
			</div>
		</div>
		<slot></slot>
	</div>
</template>

<script>
import { MENU } from '@/utils/const';

export default {
	data() {
		return {
			bannerContent: '',
			enContent: '',
			shouldHideInfo: false,
			tabHeight: 0
		};
	},
	watch: {
		'$route': {
			handler(val) {
				const { hash, name } = val;
				if (name === 'announcementSearch') {
					this.shouldHideInfo = true;
					this.$nextTick(() => {
						requestAnimationFrame(() => {
							const tabNode = document.querySelector('.header-mobile');
							this.tabHeight = tabNode.offsetHeight;
						});
					});
				} else {
					this.shouldHideInfo = false;
					this.tabHeight = 0;
				}

				const history = this.findItemRecursive(MENU(), hash ? hash.split('#')[1] : name) || [];
				this.bannerContent = val.name == 'home' ? this.$t('aidite_Investor_Relations') : history[0]?.label;
				this.enContent = history[0]?.en;
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		findItemRecursive(tree, itemId, path = []) {
			for (const item of tree) {
				if ((item.id || item.name) === itemId) {
					// 找到目标项
					return [...path, item];
				}

				if (item.children && item.children.length > 0) {
					const result = this.findItemRecursive(item.children, itemId, [...path, item]);
					if (result) {
						// 子树中找到目标项
						return result;
					}
				}
			}

			// 未找到目标项
			return null;
		}
	}
};
</script>

<style lang="less">
.Mobile {
	.header-banner {
		height: 30.6rem !important;
	}
}
</style>
<style lang="less" scoped>
.header-banner {
	height: 480px;
	position: relative;
}
.header-company-info {
	position: absolute;
	top: 207px;
	left: 0;

	.header-title {
		color: #fff;
		font-family: 'SourceHanSansCN-Medium';
		font-size: 2.5rem;
		font-style: normal;
		font-weight: 400;
		line-height: 4rem;
	}
	.header-en {
		color: #fff;
		font-family: 'SourceHanSansCN-Regular';
		font-size: 1.8rem;
		font-style: normal;
		font-weight: 500;
		line-height: 1.5rem;
	}
}
</style>
